// extracted by mini-css-extract-plugin
export var loadingSpinner = "_51-1";
export var standaloneTable = "_51-0";